import { instance } from 'api/api';
import { editorExternalReportAPI } from 'api/editor/external-report';

export async function getViewerUrl(elementId: number, segmentValueId: number) {
    return editorExternalReportAPI.buildViewerUrl(elementId, segmentValueId);
}

// Use to open external view. Will count interaction with element.
export function openExternalView(elementId: number, segmentValueId: number) {
    return instance.get(`/data/service/internal/element/${elementId}/${segmentValueId}/log-view`).finally(() =>
        getViewerUrl(elementId, segmentValueId).then((url) => {
            setTimeout(() => {
                //workaround for safari
                window.open(url, '_blank', 'noopener,noreferrer');
            }, 0);
        }),
    );
}

export function copyExternalViewUrl(elementId: number, segmentValueId: number) {
    return getViewerUrl(elementId, segmentValueId).then((url) => {
        navigator.clipboard.writeText(url);
    });
}
